// Mirrors src/feemonk-users/config.ts UserType + ROLE_SCOPE_MAP on the backend.
// There is no "list roles" endpoint, so this has to be kept in sync by hand.
export const ROLE_OPTIONS = [
    { value: 'admin', label: 'Admin' },
    { value: 'crm', label: 'Credit Risk Manager (CRM)' },
    { value: 'cra', label: 'Credit Risk Analyst' },
    { value: 'crsa', label: 'Credit Risk Senior Analyst' },
    { value: 'user', label: 'User' },
    { value: 'institute_user', label: 'Institute User' },
    { value: 'co_lender', label: 'Co-Lender' },
    { value: 'finance', label: 'Finance' },
    { value: 'collection', label: 'Collection' },
    { value: 'institute_collection', label: 'Institute Collection' },
    { value: 'institute_admin', label: 'Institute Admin' },
    { value: 'channel_user', label: 'Channel User' },
    { value: 'exec', label: 'Executive' },
    { value: 'collection_user', label: 'Collection User' },
    { value: 'end-user', label: 'End User' },
    { value: 'institute_cra', label: 'Institute CRA' },
    { value: 'collection_manager', label: 'Collection Manager' },
    { value: 'accounts', label: 'Accounts' },
    { value: 'ceo', label: 'CEO' },
    { value: 'cxo', label: 'CXO' },
    { value: 'zonal_processing', label: 'Zonal Processing' },
    { value: 'zonal_collection', label: 'Zonal Collection' },
    { value: 'fund_manager', label: 'Fund Manager' },
    { value: 'fund_user', label: 'Fund User' },
];

export const ROLE_LABEL_BY_VALUE = Object.fromEntries(ROLE_OPTIONS.map((r) => [r.value, r.label]));

// Mirrors ROLE_SCOPE_MAP in src/feemonk-users/config.ts. 'end-user' and 'co_lender'
// are intentionally absent — they have no backend entry either, so assigning either
// role will always fail server-side with "Unknown role", regardless of scope chosen.
export const ROLE_SCOPE_MAP = {
    ceo: ['all'],
    cxo: ['all'],
    admin: ['all'],
    zonal_processing: ['zone'],
    zonal_collection: ['zone'],
    collection_manager: ['team', 'all'],
    crm: ['team', 'all'],
    cra: ['team'],
    crsa: ['team'],
    accounts: ['all'],
    finance: ['all'],
    collection: ['self'],
    collection_user: ['self'],
    institute_admin: ['institute'],
    institute_user: ['institute'],
    institute_cra: ['institute'],
    fund_manager: ['fund'],
    fund_user: ['fund'],
    channel_user: ['institute'],
};

export const ALL_SCOPE_TYPES = ['all', 'zone', 'team', 'institute', 'fund', 'self'];
